import { useAppSelector } from "@/redux/hooks";
import { useCheckoutUI } from "../CheckoutUIProvider";
import { useEffect, useState } from "react";
import { Retailer } from "@/redux/types";

export const useCheckoutRetailer = () => {
  const retailers = useAppSelector((state) => state.retailers);
  const [state] = useCheckoutUI();
  const [currentRetailer, setCurrentRetailer] =
    useState<Retailer | undefined>(undefined);

  useEffect(() => {
    const retailerId = state.context.checkoutIntent?.retailerId;
    const currentRetailer =
      retailers.find((retailer) => retailer.retailerId === retailerId) ??
      undefined;
    setCurrentRetailer(currentRetailer);
  }, [state.context.checkoutIntent?.retailerId, retailers]);

  return {
    currentRetailer,
  };
};
